import { render, staticRenderFns } from "./UMLClassGroup.vue?vue&type=template&id=1d2d04ca&scoped=true&"
import script from "./UMLClassGroup.vue?vue&type=script&lang=js&"
export * from "./UMLClassGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2d04ca",
  null
  
)

export default component.exports